import RemoveIcon from '@mui/icons-material/Remove';

const MaterialRemoveIcon = () => {
  return <RemoveIcon htmlColor="#1A1A1A"></RemoveIcon>;
};

export default MaterialRemoveIcon;
